const HEADER_SCROLL_HIDE_THRESHOLD = 180;
window.addEventListener("scroll", function () {
  document.body.classList.toggle(
      "scrollHeader",
      window.scrollY >= HEADER_SCROLL_HIDE_THRESHOLD
  );
});
export default {
  init: function () {
    const scrollSnapMain = document.querySelector(".ScrollSnap main");
    if (scrollSnapMain === null) return;
      scrollSnapMain.addEventListener("scroll", function () {
      document.body.classList.toggle(
      "scrollHeader",
      scrollSnapMain.scrollTop >= HEADER_SCROLL_HIDE_THRESHOLD
    );
  });
}
};
